import { SWRConfig } from 'swr';

import serverStore from '../../lib/utils/serverStore';

import {
  leplusMagazineService,
  settingService,
} from '../../lib/services';
import { axiosInstance, getContentSmall } from '../../lib/utils';

import { withAlert, WithAlert } from '../../lib/hocs';
import Image from 'next/image';
import { Button, SanitizeHTML, Title } from '../../lib/components';
import { setGraphContext } from '../../apollo-client';
import Link from 'next/link';
import Head from 'next/head';

function Issue({ fallback, article }) {
  return (
    <div className="flex-1 py-2">
      <SWRConfig value={{ fallback }}>
        <Head>
          <title>{article.title}</title>
          <meta name="description" content={getContentSmall(article)}></meta>
        </Head>
        <section className="relative px-5 pt-10 mx-auto text-black sm:w-3/4 lg:w-3/5 sm:px-0">
          <span className="block text-base text-gray-400 mb-7"><Link href="/">Accueil</Link> / <Link href="/le-plus">Le Plus</Link> / {article.title}</span>
          <Title>
            {article.title}
          </Title>
          <div className="text-2xl leading-6 text-justify">
            <p>
              {article.description}
            </p>
          </div>
          <SanitizeHTML className="mt-8 le-plus" magazine={true} html={article.content} />
        </section>
      </SWRConfig>
    </div>
  );
}

export const getServerSideProps = withAlert(async function getServerSideProps({ req, res, params }) {
  try {
    const { url } = params;
    if (!url) {
      return {
        redirect: {
          destination: '/le-plus',
          permanent: false,
        },
      };
    }

    axiosInstance.setAxiosContext(req, res)
    setGraphContext(req, res)

    const article = await leplusMagazineService.getByUrl(url);

    let setting = serverStore.get('setting');
    let fallback = {};
    fallback[settingService.SETTING_GET_SETTING_PATH] = setting;
    return {
      props: { fallback: fallback, setting: setting, article },
    };
  } catch (e) {
    if (e?.response?.status === 404) {
      return {
        notFound: true,
      }
    }
    return {
      redirect: {
        destination: '/le-plus',
        permanent: false,
      },
    };
  }
})

export default WithAlert(Issue)